<script setup lang="ts">
import PartsCombination from '@/components/aeroUpload/PartsCombination.vue'
</script>

<template>
  <div class="aero-upload">
    <PartsCombination></PartsCombination>
  </div>
</template>

<style lang="scss" scoped>
.aero-upload {
  margin: 1.5% 3%;
}
</style>
